export default "__VITE_ASSET__DgLzyUcA__"